import { getApiBase } from '../utils/runtime';

const API_BASE = getApiBase();

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    },
    ...options
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.error || `Request failed: ${response.status}`);
  }

  if (response.status === 204) return null;
  return response.json();
}

export function fetchCareContext(userId, email) {
  const query = email ? `?email=${encodeURIComponent(email)}` : '';
  return request(`/care/users/${encodeURIComponent(userId)}/context${query}`);
}

export function saveHealthProfile(subjectId, payload) {
  return request(`/care/subjects/${encodeURIComponent(subjectId)}/profile`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
}

export function createConsent(subjectId, payload) {
  return request(`/care/subjects/${encodeURIComponent(subjectId)}/consents`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function revokeConsent(consentId, payload) {
  return request(`/care/consents/${encodeURIComponent(consentId)}/revoke`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function createObservation(subjectId, payload) {
  return request(`/care/subjects/${encodeURIComponent(subjectId)}/observations`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function createFeedback(subjectId, payload) {
  return request(`/care/subjects/${encodeURIComponent(subjectId)}/feedback`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function recordRecommendationAction(recommendationId, payload) {
  return request(`/care/recommendations/${encodeURIComponent(recommendationId)}/actions`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}
